module.exports = __webpack_public_path__ + "assets/close-white-31737b.svg";